import React from "react";
import {MapPin} from "lucide-react";
import BackToDashboardButton from "../../components/ui/BackToDashboardButton";

/**
 * Compact chrome strip for the Live Tracking page.
 *
 * Purely presentational — sits at the top of .tracking-page so the
 * existing tracking-layout (sidebar + map) keeps its full geometry.
 * Matches the DashboardHeader idiom so the redesign is consistent
 * across live screens. No WebSocket, no marker logic, no data flow
 * touched here.
 */
export default function TrackingHeader({deviceCount, isAdmin, typeLabel = "device"}) {
  return (
    <header className="shrink-0 mx-2 mt-2 px-3 sm:px-4 py-2 bg-white border border-ink-200 rounded-xl shadow-xs flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-8 w-8 rounded-lg bg-brand-50 grid place-items-center shrink-0">
          <MapPin className="h-4 w-4 text-brand-700" aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <h1 className="text-sm sm:text-base font-semibold text-ink-900 leading-tight truncate">
            Live Tracking
          </h1>
          <p className="text-xs text-ink-500 truncate">
            Real-time {typeLabel} positions
            <span className="mx-2 text-ink-300">·</span>
            <span className="font-medium text-ink-700 tabular-nums">{deviceCount}</span>{" "}
            device{deviceCount === 1 ? "" : "s"}
            {isAdmin && (
              <>
                <span className="mx-2 text-ink-300">·</span>
                <span className="text-brand-700 font-medium">Admin controls enabled</span>
              </>
            )}
          </p>
        </div>
      </div>
      <BackToDashboardButton className="shrink-0" />
    </header>
  );
}
